// 9fbef606107a605d69c0edbcd8029e5d
import { css } from 'styled-components';

export default css`
  a {
    display: inline-block;
  }

  img {
    width: 172px;
    height: 62px;
    &.snj {
      height: 62px !important;
      margin-top: -5px;
      margin-left: 15px;
    }
  }
`;
